import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const productLinks = [
    { name: 'LinkIQ', url: 'https://linkiq.pro/' },
    { name: 'Opti Flo Connect', url: 'https://connect.optiflo.app/' },
    { name: 'HighReach Apps', url: 'https://highreachapps.com/' },
    { name: 'Voyae', url: 'https://govoyae.com/' }
  ];

  const companyLinks = [
    { name: 'About', path: '/about' },
    { name: 'Partnerships', path: '/partnerships' },
    { name: 'Contact', path: '/contact' }
  ];

  const legalLinks = [
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Terms of Use', path: '/terms' },
    { name: 'Cookie Policy', path: '/cookies' }
  ];

  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="container mx-auto px-5 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Logo & Description */}
          <div className="md:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_optiflo-corporate/artifacts/po6a6tm2_Opti%20Flo%20Logo%20P3d%20White.png" 
              alt="Opti Flo Apps Ltd" 
              className="h-8 w-auto mb-4"
            />
            <p className="body-small text-on-dark text-muted-dark">
              AI-first platforms and integrations for modern businesses.
            </p>
          </div>

          {/* Products */}
          <div>
            <h3 className="heading-6 mb-4">Products</h3>
            <ul className="space-y-2">
              {productLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.url}
                    className="body-small text-on-dark text-muted-dark hover:text-[#f43cde] transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="heading-6 mb-4">Company</h3>
            <ul className="space-y-2">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="body-small text-on-dark text-muted-dark hover:text-[#f43cde] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="heading-6 mb-4">Legal</h3>
            <ul className="space-y-2">
              {legalLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="body-small text-on-dark text-muted-dark hover:text-[#f43cde] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <p className="caption text-on-dark text-muted-dark text-center">
            © {currentYear} Opti Flo Apps Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};